import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ImageGuidelinesComponent } from './image-guidelines/image-guidelines.component';
import { UploadIdComponent } from './upload-id/upload-id.component';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { IdentityEnum } from 'src/app//shared/models/users/users/enums/IdentityEnum';
import { SubmitReasonComponent } from 'src/app/shared/components/submit-reason/submit-reason.component';
import { FieldTypes } from 'src/app//shared/models/global/FieldTypes';
import { AttachmentsValueModel } from 'src/app//shared/models/lookups/AttachmentsValueModel';
import { RolesEnum } from 'src/app//shared/models/users/roles/enums/roles';
import { UserDetails } from 'src/app//shared/models/users/users/UserDetails';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { SwalService } from 'src/app/shared/services/swal.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { UserFormComponent } from '../user-management/user-form/user-form.component';
import { VerifyMobileComponent } from 'src/app/shared/components/verify-mobile/verify-mobile.component';
import { ModelsEnum } from 'src/app/shared/models/users/users/enums/ModelsEnum';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { ChangeUsernameComponent } from '../change-username/change-username.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
  user!: UserDetails;
  dataLoading = false;
  loading = false;
  userId = 9;
  IdentityEnum = IdentityEnum;

  // image file
  avatar: any;
  avatarSrc!: string;
  maxFileSize = 0.8;
  fileTypeError = false;
  fileSizeError = false;
  openSideNav!: boolean;
  selectedAttachment!: AttachmentsValueModel;

  constructor(
    private service: UsersService,
    public dialog: MatDialog,
    private auth: AuthenticationService,
    private swalService: SwalService,
    private translate: TranslateService
  ) { }

  ngOnInit() {
    this.getDetails();
    this.auth.currentUserSubject.subscribe((user: any) => {
      if (user) {
        this.getDetails();
      }
    });
  }

  getDetails(reload = true) {
    this.dataLoading = reload;
    this.service.getUserProfile().subscribe(
      (data: any) => {
        this.dataLoading = false;
        if (data) {
          this.user = data as UserDetails;
          this.clear();
        }
      },
      (error: any) => {
        this.dataLoading = false;
      }
    );
  }

  changePassword() {
    const dialogRef = this.dialog.open(ChangePasswordComponent, {
      width: '540px',
      data: {},
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // console.log(result);
      }
    });
  }

  changeUsername() {
    const dialogRef = this.dialog.open(ChangeUsernameComponent, {
      width: '540px',
      data: {
        userName: this.user.userName,
      },
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        // console.log(result);
      }
    });
  }

  editProfile() {
    console.log(ModelsEnum.profile);

    const dialogRef = this.dialog.open(UserFormComponent, {
      width: '620px',
      data: {
        record: this.user,
        userId: this.userId,
        model: ModelsEnum.profile, // LAB, Sc, VL
        isModuleAdmin: null,
        isTrainer: this.hasPermission(RolesEnum.Trainer),
        // isPathologist: true,
      },
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getDetails();
      }
    });
  }

  checkRole(item: string) {
    if (this.user.roles) {
      return this.user.roles.includes(item);
    }
    return false;
  }

  // File preview with validation
  uploadAvatar($event: any): void {
    const file: File = $event.target.files[0];
    if (file && this.validateFile(file)) {
      this.readThis(file);
      this.avatar = file;
    } else {
      this.clear();
    }
  }
  readThis(file: File): void {
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      // this.user.userImage = myReader.result as string;
      this.avatarSrc = myReader.result as string;
    };
  }
  validateFile(file: File): any {
    if (this.fileType(file.name)) {
      this.fileTypeError = false;
      if (file.size / (1024 * 1024) <= this.maxFileSize) {
        this.fileSizeError = false;
      } else {
        this.fileSizeError = true;
        return false;
      }
    } else {
      this.fileTypeError = true;
      return false;
    }
    return true;
  }
  fileType(fileName: any): any {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      default:
        return false;
    }
  }

  updateAvatar() {
    if (this.avatarSrc) {
      this.loading = true;
      const formData = new FormData();
      formData.append('userImage', this.avatar, this.avatar.name);
      this.service.changeProfilePicture(formData).subscribe(
        () => {
          this.loading = false;
          this.getDetails(false);
          this.swalService
            .swalSuccess(this.translate.instant('swalMsg.updatedsuccessfully'))
            .then(() => { });
        },
        (err: any) => {
          this.loading = false;
        }
      );
    }
  }

  clear() {
    this.avatarSrc = this.user.userImage;
    this.avatar = undefined;
  }

  verifyMobile() {
    const dataRecord = {
      verifyEntityUserMobile: true,
      title: this.translate.instant('profile.verifyMobile'),
      message: this.translate.instant('profile.otpSent'),
    };
    const dialogRef = this.dialog.open(VerifyMobileComponent, {
      width: '750px',
      data: dataRecord,
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.getDetails();
      }
    });
  }
  openImageGuidelines() {
    if (!this.user.identityImage) {
      const dialogRef = this.dialog.open(ImageGuidelinesComponent, {
        width: '750px',
      });
      dialogRef.afterClosed().subscribe((res: any) => {
        if (res) {
          this.addEditId();
        }
      });
    } else {
      this.addEditId();
    }
  }
  addEditId() {
    const dialogRef = this.dialog.open(UploadIdComponent, {
      width: '550px',
      data: this.user.identityImage
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          width: '600px',
          disableClose: true,
          data: {
            title: this.translate.instant(
              'imageGuidelines.IDDocumentValidationProgress'
            ),
            message: this.translate.instant(
              'imageGuidelines.validatingIDdocumentPleaseWaitFewSeconds'
            ),
            lottieFile: '/assets/js/id_verification.json',
            btnClass: 'd-none',
            serviceTarget: 'validateImageAndUpdatePathologyData',
            // service: this.traineeIdentityVerificationService,
            record: data,
            returnErrorDTO: true,
            hideSwalMessageSuccess: true,
            autoConfirm: true,
          },
        });
        dialogRef.afterClosed().subscribe((uploadRes: any) => {
          if (uploadRes) {
            if (uploadRes instanceof Object) {
              // error
              if (uploadRes.ErrorDTO && uploadRes.ErrorDTO.length) {
                let title;
                if (
                  uploadRes.ErrorDTO[0].ErrorCode ==
                  IdentityEnum.WIDTH_NOT_MATCH_MINWIDTH
                ) {
                  title = this.translate.instant(
                    'imageGuidelines.TheWidthMinimumWidth'
                  );
                } else if (
                  uploadRes.ErrorDTO[0].ErrorCode ==
                  IdentityEnum.HORIZONTALDPI ||
                  uploadRes.ErrorDTO[0].ErrorCode ==
                  IdentityEnum.IMAGE_RESOLUTION
                ) {
                  title = this.translate.instant(
                    'imageGuidelines.ImageResolution'
                  );
                } else if (
                  uploadRes.ErrorDTO[0].ErrorCode == IdentityEnum.NO_FACE_DETECT
                ) {
                  title = this.translate.instant(
                    'imageGuidelines.NoFaceDetect'
                  );
                } else if (
                  uploadRes.ErrorDTO[0].ErrorCode ==
                  IdentityEnum.HEIGHT_NOT_MATCH_MINHEIGHT
                ) {
                  title = this.translate.instant(
                    'imageGuidelines.TheHightMinimumHight'
                  );
                } else if (
                  uploadRes.ErrorDTO[0].ErrorCode == IdentityEnum.IMAGE_ROTATION
                ) {
                  title = this.translate.instant(
                    'imageGuidelines.ImageRotation'
                  );
                }
                const dialogRef = this.dialog.open(
                  ConfirmationDialogComponent,
                  {
                    width: '600px',
                    data: {
                      img: 'assets/images/icons/illustration_identity_not_uploaded.svg',
                      title: title,
                      message: uploadRes.ErrorDTO[0].Error,
                      btnClass: 'larg-btn w-50',
                      btnTitle: this.translate.instant('imageGuidelines.retry'),
                      btnCancel: true,
                      btnCancelClass: 'w-50',
                    },
                  }
                );
                dialogRef.afterClosed().subscribe((retryRes: any) => {
                  if (retryRes) {
                    if (!this.user.identityImage) {
                      this.openImageGuidelines()
                    } else {
                      this.addEditId();
                    }
                  }
                });
              }
            } else {
              const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
                width: '600px',
                data: {
                  img: 'assets/images/icons/done_illustration.svg',
                  title: this.translate.instant(
                    'imageGuidelines.IDDocumentSuccessfullyValidatedSubmitted'
                  ),
                  btnTitle: this.translate.instant('courses.done'),
                  btnClass: 'larg-btn',
                },
              });
              dialogRef.afterClosed().subscribe(() => {
                this.getDetails()
              })
            }
          }
        });
      }
    });
  }

  addBio() {
    const dataRecord = {
      record: {
        // caseId: this.caseId,
        // caseIdType: this.caseIdType,
      },
      service: this.service,
      serviceTarget: 'addOrUpdateTrainerBio',
      title: this.translate.instant('profile.addBio'),
      btnSubmitTitle: this.translate.instant('forms.Submit'),
      fields: [
        {
          id: 'ProfessionalSummary',
          inputTypeId: FieldTypes.TEXTAREA,
          inputTitle: this.translate.instant('profile.professionalSummary'),
          value: this.user.professionalSummary,
          isMandatory: true,
          fieldLength: 1000
        },
        {
          id: 'EducationAndCertificate',
          inputTypeId: FieldTypes.TEXTAREA,
          inputTitle: this.translate.instant('profile.educationAndCertificate'),
          value: this.user.educationAndCertificate,
          isMandatory: true
        },
        {
          id: 'Specializations',
          inputTypeId: FieldTypes.TEXTAREA,
          inputTitle: this.translate.instant('profile.specializations'),
          value: this.user.specializations,
          isMandatory: true,
          fieldLength: 255
        },
        {
          id: 'TrainerCv',
          inputTypeId: FieldTypes.FILE,
          inputTitle: this.translate.instant('profile.cv'),
          value: this.user.trainerCv ? [this.user.trainerCv] : [],
          isMandatory: false,
          deletedAttachments: [],
          deletedKey: 'DeletedCv',
          maxSize: 5,
          maxFiles: 1,
          allowedExt: ['jpeg', 'jpg', 'png', 'pdf']
        },
      ],
    };
    const dialogRef = this.dialog.open(SubmitReasonComponent, {
      width: '600px',
      data: dataRecord,
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.getDetails();
      }
    });
  }

  openSidenav(attachment: AttachmentsValueModel) {
    this.selectedAttachment = attachment;
    this.openSideNav = true;
  }

  closeSidenav(e: any) {
    this.openSideNav = false;
  }

  hasPermission(permission: string) {
    return this.auth.hasPermission(permission);
  }
}
